import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { brandsApi } from 'entities/Brand';
import { EApiTags } from 'shared/typings';

export const useInvalidateBrands = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(brandsApi.util.invalidateTags([EApiTags.BRANDS_LIST]));
	}, []); // eslint-disable-line
};
